import { makeStyles, tokens } from '@fluentui/react-components';
import { containerQueryMin, px } from '@this/app-shared/dist/tools/styles.js';
import { COLUMN_GAP, COLUMN_SIZE } from '../shared.js';

export function calculateGridColumns(numOfCols: number) {
    const absCols = Math.abs(numOfCols);

    const colsSize = absCols * COLUMN_SIZE;
    const gapSize = (absCols - 1) * COLUMN_GAP;

    return px(colsSize + gapSize);
}

export const useStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
    },
    span2: {
        [containerQueryMin(calculateGridColumns(2))]: {
            gridColumn: 'span 2',
        },
    },
    spanAll: {
        gridColumn: '1 / -1',
    },
    label: {
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        color: tokens.colorNeutralForegroundDisabled,
    },
    valueContainer: {
        display: 'flex',
        gap: tokens.spacingHorizontalS,
    },
    valueError: {
        color: tokens.colorStatusDangerForeground1,
    },
    valueAction: {
        textDecoration: 'underline',
        cursor: 'pointer',
        '& a': {
            color: 'inherit',
        },
    },
    valueActions: {
        display: 'flex',
        gap: tokens.spacingHorizontalXS,
    },
    valueIndicator: {
        display: 'flex',
        fontSize: tokens.fontSizeBase500,
    },
    skeletonItem: {
        height: tokens.fontSizeBase500,
    },
});
